import { Modal } from "@ctsu/react-ctsu-ui";
import TabedLink from "components/common/TabedLink";
import { text } from "components/common/Text";
import { getEncodedQueryParams } from "helpers/utils";
import React from "react";

const getToURL = (siteCtepId, userGroup) =>
  getEncodedQueryParams(
    "/institution/roster/affiliation",
    `ctepid=${siteCtepId}&userGroup=${userGroup}`
  );
export default function OldOrNewSiteModal({ siteInfoObject, onClose, userGroup }) {
  const goText = text("institution.search.go_to");
  const newText = text("institution.search.new");
  const oldText = text("institution.search.old");
  return (
    <Modal onClose={onClose} modalTitle={text("institution.search.inst_finder")} className="inst-search-modal">
      <div className="mb-3">
        {`${text("institution.search.institution")} ${siteInfoObject.siteCtepId} ${
          text(
            "institution.search.replaced_with"
          )
        } ${siteInfoObject.newCtepId}${text("institution.search.what_you_like_to_do")}`}
      </div>
      {/* old site Id */}
      <div className="align-center">
        <TabedLink
          url={getToURL(siteInfoObject.siteCtepId, userGroup)}
          text={`${goText} ${siteInfoObject.siteCtepId} ${oldText}`}
          id="btn-go-to-old"
        />
      </div>
      {/* new site Id */}
      <div className="align-center">
        <span></span>
        <span className="px-1">{}</span>
        <TabedLink
          url={getToURL(siteInfoObject.newCtepId, userGroup)}
          text={`${goText} ${siteInfoObject.newCtepId} ${newText}`}
          id="btn-go-to-new"
        />
      </div>
    </Modal>
  );
}
